module.exports = __webpack_public_path__ + "static/media/nullw500.182fefd9.png";